module.exports = __webpack_public_path__ + "static/media/Thirdpartypet.cbeb8c4a.svg";